import React from 'react';
import './Agenda.css';
import VideoPresent from './VideoPresent/VideoPresent';
import Weidlich from '../../img/agenda/Weidlich.png'
import Contxtual from '../../img/agenda/Contxtual.png'
import Bondkovskii from '../../img/agenda/Bondkovskii.png'
import Soramitsu from '../../img/agenda/Soramitsu.png'
import Gautam from '../../img/agenda/Gautam.png'
import Mfable from '../../img/agenda/Mfable.png'

import btn_arrow from "../../img/btn_arrow.svg";

export default class Agenda extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [
                {
                    time: '10:10',
                    day: 'Wednesday, Oct 09',
                    photo: Weidlich,
                    name: 'Oliver Weidlich',
                    position: 'Director of Design & Innovation',
                    ln: 'https://www.linkedin.com/in/oliverw/',
                    linkAdd: 'https://calendar.google.com/calendar/u/0/r/eventedit?text=How+context+can+enhance+the+Spatial+Computing+User+Experience&dates=20241009T101000Z/20241009T111000Z&details=One+of+the+opportunities+for+spatial+computing+is+to+orientate+digital+content+and+experiences+within+the+physical+world.%C2%A0+But+there+are+many+aspects+of+the+physical+world+that+we+can+combine+with+personal+information+and+digital+content+that+can+make+our+experiences+easier,+and+more+engaging.+Oliver+will+talk+about+how+we+can+use+elements+of+context%C2%A0+to+design+better+spatial+computer+experiences+and+will+use+the+case+study+of+their+Apple+Vision+Pro+app,+Day+Ahead.&location=online',
                    logo: Contxtual,
                    title: 'How context can enhance the Spatial Computing User Experience',
                    abstract: `One of the opportunities for spatial computing is to orientate digital content and experiences within the physical world.  But there are many aspects of the physical world that we can combine with personal information and digital content that can make our experiences easier, and more engaging. Oliver will talk about how we can use elements of context  to design better spatial computer experiences and will use the case study of their Apple Vision Pro app, Day Ahead.`,
                },
                {
                    time: '10:40',
                    day: 'Wednesday, Oct 09',
                    photo: Bondkovskii,
                    name: 'Evgenii Bondkovskii',
                    position: 'Senior Product Designer',
                    ln: 'https://www.linkedin.com/in/evgeny-bondkovski-a2b41aa0/',
                    linkAdd: 'https://calendar.google.com/calendar/u/0/r/eventedit?text=Why+a+Product+Designer+is+More+Than+an+Interface+Designer:+The+Shift+in+Modern+UI+Design+Paradigms&dates=20241009T104000Z/20241009T114000Z&details=Why+is+a+product+designer+not+an+interface+designer?+First+of+all,+they+should+solve+the+task+of+the+product,+not+the+tasks+of+the+user.+Of+course,+a+more+convenient+app+is+better+for+the+business.+However,+when+you+designing+an+interface,+it+is+always+necessary+to+look+back+at+the+main+business+task+and+it+is+desirable+to+roughly+understand+the+cost+of+developing+and+implementing+a+particular+features.+Thus,+instead+of+the+user+standing+in+the+center,+a+triangle+arises:+product-owner+-+user+-+developers,+working+within+which+the+product+designer+must+find+optimal+solutions+and+a+delicate+balance.+I%27ll+show+how+it+works+using+specific+examples+from+my+own+practice.&location=online',
                    logo: Soramitsu,
                    title: 'Why a Product Designer is More Than an Interface Designer: The Shift in Modern UI Design Paradigms',
                    abstract: `Why is a product designer not an interface designer? First of all, they should solve the task of the product, not the tasks of the user. Of course, a more convenient app is better for the business. However, when you designing an interface, it is always necessary to look back at the main business task and it is desirable to roughly understand the cost of developing and implementing a particular features. Thus, instead of the user standing in the center, a triangle arises: product-owner - user - developers, working within which the product designer must find optimal solutions and a delicate balance. I'll show how it works using specific examples from my own practice.`,
                },
                {
                    time: '11:10',
                    day: 'Wednesday, Oct 09',
                    photo: Gautam,
                    name: 'Prasanta Gautam',
                    position: 'Founder',
                    ln: 'https://www.linkedin.com/in/pkgautam/',
                    linkAdd: 'https://calendar.google.com/calendar/u/0/r/eventedit?text=Designing+Better+UI+for+Automobile+Dashboards&dates=20241009T111000Z/20241009T121000Z&details=Covering+use+cases,+best+practices,+and+the+latest+trends+with+showcase+some+of+our+past+projects+as+examples.&location=online',
                    logo: Mfable,
                    title: 'Designing Better UI for Automobile Dashboards',
                    abstract: `Covering use cases, best practices, and the latest trends with showcase some of our past projects as examples.`,
                },
                {
                    time: '11:40',
                    day: 'Wednesday, Oct 09',
                    name: 'Q&A SESSION',
                    title: 'Speakers: Prasanta Gautam, Oliver Weidlich, Evgenii Bondkovskii',
                },
            ],
        }
    }

    render() {
        return (
            <div className="agenda" id='agenda'>
                <div className='container agenda'>
                    <h2 className="agenda_title">Agenda</h2>
                    <VideoPresent speakers={this.state.list} />
                    <a className='button agenda_full_btn' href='https://geekle.us/schedule/uiux24' target='_blank' rel="noreferrer">
                        <span>SHOW MORE</span>
                        <img className='main_btn_img' src={btn_arrow} alt="" />
                    </a>
                </div>
            </div>
        );
    }
};